import { ListingV2 } from 'types/listings';
import { NormalizedPublicListing } from 'types/listingV3';

const normalizeListingV2 = (listing: ListingV2): NormalizedPublicListing => {
  return {
    bookingAvailabilityMode: listing.bookingAvailabilityMode,
    brandId: listing.brandId,
    categoryId: listing.category?.id ?? undefined,
    categoryName: listing.category?.name ?? undefined,
    dates: listing.dates,
    experienceId: listing.experienceId,
    hidePrice: listing.hidePrice,
    hostedBy: listing.hostedById
      ? {
          id: listing.hostedById, // hostedById is the only host specific field in v2 schema
          firstName: '',
          lastName: '',
          description: undefined,
          profilePicture: undefined,
        }
      : null,
    id: listing.id,
    isExclusive: listing.isExclusive,
    kind: listing.kind,
    maxParticipants: listing.maxParticipants,
    medias: listing.medias,
    pointsEligible: listing.pointsEligible,
    productLine: listing.productLine,
    promotedListing: null,
    rating: listing.rating,
    resourceGroupCollectionId: listing.resourceGroupCollectionId,
    resourceGroups: [],
    advertisedPrice: listing.advertisedPrice,
    slug: listing.slug,
    startingPrice: listing.startingPrice,
    summary: listing.summary,
    title: listing.title,
    vibes: listing.vibes.map((vibe) => ({
      id: vibe.id,
      brandId: listing.brandId ?? '', // @todo-v3: type mismatch here. Do I even need brandId here?
      name: vibe.name,
    })),
  };
};

export default normalizeListingV2;
